import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';
import { Theme } from '@material-ui/core';

export default ({ typography }: Theme) =>
  createStyles({
    container: {
      borderBottom: `1px solid ${palette.lightGray}`,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      padding: '10px 0px',
      width: '100%',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
      '& svg': {
        fontSize: 12,
        marginRight: 4,
      },
    },
    textLight: {
      color: palette.strongGray,
    },
    title: {
      marginBottom: 10,
      display: 'flex',
    },
    dataContainer: {
      marginLeft: 100,
    },
    strong: {
      marginLeft: 15,
      color: palette.strongGray,
    },
    operator: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 15,
    },
    info: {
      background: palette.green,
      color: palette.white,
      padding: 5,
      borderRadius: 4,
      width: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      marginBottom: 10,
    },
    error: {
      background: palette.red,
      color: palette.white,
      padding: 5,
      borderRadius: 4,
      width: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      marginBottom: 18,
    },
    warning: {
      background: palette.deepBlue,
      color: palette.white,
      padding: 5,
      borderRadius: 4,
      width: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      marginBottom: 18,
    },
    buttons: {
      margin: '36px 0px 8px 40px',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 8,
        margin: '0 8px',
        fontSize: 14,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    grid: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      boxSizing: 'border-box',
    },
    work: { marginTop: 5 },
  });
